import React, { useState } from 'react';
import { TTextTranslationNamespaces } from 'types';
import { useTranslation } from 'react-i18next';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import classNames from 'classnames';

interface IProps {
	children: React.ReactNode;
	translationKey: string;
	translationNameSpace?: TTextTranslationNamespaces;
	testId: string;
	isCollapsible?: boolean;
}

export const FormSection: React.FC<IProps> = ({
	children,
	translationKey,
	translationNameSpace = 'form',
	testId,
	isCollapsible = true,
}) => {
	const { t } = useTranslation('form');
	const [isOpen, setIsOpen] = useState<boolean>(true);

	const handleToggle = () => {
		setIsOpen((prevIsOpen) => !prevIsOpen);
	};

	return (
		<div className="p-4 rounded flex flex-col gap-4 bg-blue-00-new" data-test={testId}>
			<div className="flex items-center gap-4">
				<Text
					className="flex-1"
					translationNameSpace={translationNameSpace}
					translationKey={translationKey}
					theme="neutralDark"
					size="xl"
					weight="bold"
				/>
				{isCollapsible && (
					<NewButton
						variant="ghost"
						size="small"
						icon={true}
						iconLeft={<Icon name={isOpen ? IconName.chevronUp : IconName.chevronDown} size="lg" />}
						ariaLabel={t(isOpen ? 'hideBlockButton' : 'expandBlockButton')}
						testId={`${testId}Toggle`}
						onClick={handleToggle}
					/>
				)}
			</div>
			<div className={classNames({ hidden: !isOpen })}>{children}</div>
		</div>
	);
};
